'use strict'

const popin =  {
    init: function(){
        let html = document.querySelector('html'),
            body = document.querySelector('body'),
            height = window.innerHeight,
            openBtn = document.querySelector('.footer_nav a[href="#popin_recrutement"]'),
            popinRecrutement = document.querySelector('.popinRecrutement'),
            closeBtn = document.querySelector('.popinRecrutement_close'),
            voile = document.querySelector('.voile');

        if(openBtn && popinRecrutement && closeBtn) {
            openBtn.addEventListener('click', function() {
                html.style.height = height + 'px';
                body.style.height = height + 'px';
                voile.style.display = 'block';
                popinRecrutement.style.display = 'block';
                setTimeout(() => {
                    html.classList.add('popin-opened');
                }, 50);
            });
            closeBtn.addEventListener('click', function() {
                html.classList.remove('popin-opened');
                html.style.height = '';
                body.style.height = '';
                setTimeout(() => {
                    voile.style.display = 'none';
                    popinRecrutement.style.display = 'none';
                }, 200);
            });
        }
    },
}

export default popin;



// WEBPACK FOOTER //
// ./src/scripts/components/popin.js